var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotIncludedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 16.856,
    width: 16.7671,
    height: 1.62559,
    rx: 0.812797,
    transform: "rotate(-45 5 16.856)",
    fill: "#F84B7A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9629,
    y: 18.0254,
    width: 16.7671,
    height: 1.62559,
    rx: 0.812797,
    transform: "rotate(-135 16.9629 18.0254)",
    fill: "#F84B7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotIncludedIcon);
export default __webpack_public_path__ + "static/media/not-included-icon.427ea3ef38029bd4e89025961920137d.svg";
export { ForwardRef as ReactComponent };